/* exit-offer.js -- prodbycamm exit-intent "try the free version" dialog. LOCAL ONLY (2026-10-05). Spec: pages-v0/EXIT-OFFER.md
   camm (2026-10-05): "if someone tries to click off any page of a kit that costs money and we check their acct and they
   do not alr have it, they'll be prompted to simply type in their email to try the free version of it. again, we have to
   double check to verify theyve never ever received that kit from anything before."

   Include (one per paid page):  <script src="../assets/exit-offer.js" data-kit="ac2|guide|starlight" defer></script>
   Mark-only (thanks / free pages, never shows):  <script src="../assets/exit-offer.js" data-mark="ac1" defer></script>
   Optional attrs: data-endpoint="/apps/pipeline-sync" (layer c, server ownership check + send)
                   data-fallback="ac1" (starlight only -- Starlight has NO free version; see spec)
   Test URLs: ?exit=now (force open, skips the 7-day memory; ownership still blocks) · ?exit=reset (clears every flag) · demo emails: x+owned@y.com, x+fail@y.com

   Ownership is checked in 3 layers and the dialog fails CLOSED (no send) if a check cannot run:
     (a) Liquid: window.PBC_XO_CTX = {loggedIn, email, owns:{paid,free}} from snippets/exit-offer-gate.liquid -> owns = never show
     (b) this browser: localStorage/cookie "have" list + 7-day seen stamp + live /cart.js (Shopify only)
     (c) server on submit: MailerLite groups + Shopify orders by email + claim ledger, BEFORE anything is sent */
(function () {
  'use strict';
  var me = document.currentScript || document.querySelector('script[src*="exit-offer.js"]');
  var attr = function (n) { return me ? (me.getAttribute(n) || '') : ''; };

  /* ---- the offers. Handles + group ids verified 2026-10-05 (live /products.json + MailerLite group map).
     NEVER add a kit here without a REAL free version (upsell map: "Do not invent a free demo SKU"). */
  var KITS = {
    ac2: {
      paidHandle: 'analog-crate-vol-2-one-shot-phrase-kit',
      freeKey: 'ac1', freeHandle: 'analog-crate-vol-1-cart-backing', freeGroup: '183761355660067920', /* kit_ac1 */
      eyebrow: 'Before You Go',
      title: 'Not Ready For Vol.\u00a02? Take Vol.\u00a01 Free.',
      sub: 'Hear the crate in your own beat before you spend a dollar. Type your email and Vol.\u00a01 lands in your inbox in seconds.',
      button: 'Get It Free',
      sentTitle: 'Check Your Inbox.',
      sentBody: 'Analog Crate Vol. 1 is on the way. Not there? Check promotions or spam.',
      ownedTitle: 'You Already Have It.',
      ownedBody: 'This email already has the kit. Search your inbox for "Analog Crate" to find your download.',
      search: 'Analog Crate'
    },
    guide: {
      paidHandle: 'networking-guide-product-backing',
      freeKey: 'fztp-preview', freeHandle: 'free-preview-from-zero-to-platinum-my-ultimate-networking-guide',
      freeGroup: '183835878029788395', /* guide_ftzp_demo -- data-todo: confirm vs the page form's group, see spec */
      eyebrow: 'Before You Go',
      title: 'Not Ready To Buy? Read The Free Preview.',
      sub: 'See how the DMs and loop collabs work before you spend a dollar. Type your email and the preview lands in your inbox in seconds.',
      button: 'Send Me The Preview',
      sentTitle: 'Check Your Inbox.',
      sentBody: 'The preview is on the way. Not there? Check promotions or spam.',
      ownedTitle: 'You Already Have It.',
      ownedBody: 'This email already has the guide. Search your inbox for "From Zero to Platinum" to find it.',
      search: 'From Zero to Platinum'
    },
    /* Starlight has NO free version (no free Starlight product, no Starlight demo group; the AC2 demo is DRAFT).
       Default = the dialog does not run. data-fallback="ac1" turns on an HONEST free-kit fallback (not called a Starlight version). */
    starlight: {
      paidHandle: 'starlight-multi-kit-product-backing',
      freeKey: null,
      fallback: {
        ac1: {
          freeKey: 'ac1', freeHandle: 'analog-crate-vol-1-cart-backing', freeGroup: '183761355660067920',
          eyebrow: 'Before You Go',
          title: 'Not Ready For Starlight? Start With A Free Kit.',
          sub: 'Analog Crate Vol. 1 costs nothing. Type your email and it lands in your inbox in seconds.',
          button: 'Get It Free',
          sentTitle: 'Check Your Inbox.',
          sentBody: 'Analog Crate Vol. 1 is on the way. Not there? Check promotions or spam.',
          ownedTitle: 'You Already Have It.',
          ownedBody: 'This email already has the kit. Search your inbox for "Analog Crate" to find your download.',
          search: 'Analog Crate'
        }
      }
    }
  };

  var CFG = {
    cooldownDays: 7,
    armMs: 5000,            /* desktop: no exit trigger in the first 5s */
    mobileDwellMs: 10000,   /* mobile: nothing in the first 10s */
    fastUpPx: 0.5,          /* mobile: scroll up >= 50% of a screen ... */
    fastUpMs: 400,          /* ... within 400ms */
    fastUpMinDepth: 35,     /* ... after reaching 35% depth */
    idleMs: 30000,          /* mobile: 30s idle ... */
    idleMinDepth: 60,       /* ... after reaching 60% depth */
    keySeen: 'pbc_xo_seen_v1', keyHave: 'pbc_xo_have_v1', keySitePopup: 'pbc_popup_v1',
    neverPaths: [/^\/free/, /^\/thanks/, /^\/offer-/, /^\/pages\/analog-crate-vol-1/, /^\/pages\/free-kit/, /^\/cart/, /^\/checkout/, /^\/account/, /^\/pages-v0\/(free|thanks|offer-)/]
  };

  /* ---- storage (try/catch everywhere; cookie mirror for browsers that wipe localStorage) */
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function lsDel(k) { try { localStorage.removeItem(k); } catch (e) {} }
  function ckGet(k) { var m = document.cookie.match(new RegExp('(?:^|; )' + k + '=([^;]*)')); return m ? decodeURIComponent(m[1]) : null; }
  function ckSet(k, v, days) { try { document.cookie = k + '=' + encodeURIComponent(v) + '; Max-Age=' + Math.round(days * 86400) + '; Path=/; SameSite=Lax'; } catch (e) {} }
  function get(k) { return lsGet(k) || ckGet(k); }
  function set(k, v, days) { lsSet(k, v); ckSet(k, v, days); }
  function haveList() { try { return JSON.parse(get(CFG.keyHave) || '[]') || []; } catch (e) { return []; } }
  function markHave(key) {
    if (!key) return;
    var l = haveList(); if (l.indexOf(key) < 0) l.push(key);
    set(CFG.keyHave, JSON.stringify(l), 3650);
  }
  function has(key) { return !!key && haveList().indexOf(key) >= 0; }
  function stampSeen() { set(CFG.keySeen, String(Date.now()), CFG.cooldownDays); }
  function reset() { lsDel(CFG.keySeen); lsDel(CFG.keyHave); ckSet(CFG.keySeen, '', 0); ckSet(CFG.keyHave, '', 0); }
  function emit(type, extra) {
    try { document.dispatchEvent(new CustomEvent('pbc:exit-offer', { detail: Object.assign({ type: type, kit: kitName }, extra || {}) })); } catch (e) {}
  }

  var qs = new URLSearchParams(location.search);
  if (qs.get('exit') === 'reset') reset();
  var force = qs.get('exit') === 'now';
  var kitName = attr('data-kit');

  /* public hooks: the /free form, the site popup (producer/both) and thanks pages call markHave('ac1') */
  window.PBCExitOffer = { markHave: markHave, has: has, reset: reset, open: function () { if (offer) start(true); } };

  /* mark-only mode: thanks/free pages record that this browser received the free kit, and never show anything */
  if (attr('data-mark')) { attr('data-mark').split(',').forEach(function (k) { markHave(k.trim()); }); return; }

  var kit = KITS[kitName];
  if (!kit) return;
  var offer = kit;
  if (!kit.freeKey) {                         /* no real free version */
    var fb = attr('data-fallback');
    if (!fb || !kit.fallback || !kit.fallback[fb]) return;
    offer = Object.assign({ paidHandle: kit.paidHandle }, kit.fallback[fb]);
  }
  var paidKey = 'paid:' + offer.paidHandle;

  /* ---- layer (b): page + browser gates. Returns a reason string when the dialog must NOT run. */
  function blockedReason() {
    var path = location.pathname;
    for (var i = 0; i < CFG.neverPaths.length; i++) if (CFG.neverPaths[i].test(path)) return 'never-path';
    if (document.body && document.body.hasAttribute('data-no-exit-offer')) return 'opt-out';
    if (has(offer.freeKey)) return 'has-free';
    if (has(paidKey)) return 'has-paid';
    var ctx = window.PBC_XO_CTX;                                     /* layer (a), written by Liquid */
    if (ctx && ctx.owns && (ctx.owns.paid || ctx.owns.free)) return 'liquid-owns';
    if (force) return '';
    var seen = +get(CFG.keySeen) || 0;
    if (seen && Date.now() - seen < CFG.cooldownDays * 864e5) return 'cooldown';
    var sitePop = +lsGet(CFG.keySitePopup) || 0;                      /* never stack on the site-wide signup popup */
    if (sitePop && Date.now() - sitePop < 10 * 60e3) return 'site-popup-recent';
    return '';
  }
  function otherDialogOpen() {
    if (document.querySelector('.pbc-pop.is-open, dialog[open]')) return true;
    /* any OTHER visible modal (e.g. a Shopify Forms popup). Hidden markup with aria-modal does not count. */
    var ms = document.querySelectorAll('[aria-modal="true"]:not(.pbc-xo__card)');
    for (var i = 0; i < ms.length; i++) {
      var r = ms[i].getBoundingClientRect(), cs = getComputedStyle(ms[i]);
      if (r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && +cs.opacity > 0.05) return true;
    }
    return false;
  }
  /* live cart (Shopify only): buying it right now = never interrupt; owning the free one = never offer */
  function cartCheck() {
    if (!/prodbycamm\.com$|myshopify\.com$/.test(location.hostname)) return Promise.resolve('');
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (c) {
        var hs = (c.items || []).map(function (it) { return it.handle; });
        if (hs.indexOf(offer.paidHandle) >= 0) return 'in-cart-paid';
        if (hs.indexOf(offer.freeHandle) >= 0) return 'in-cart-free';
        return '';
      })['catch'](function () { return ''; });
  }

  /* track media so the idle trigger never fires while a preview is playing (pages use new Audio(), not in the DOM) */
  var playing = [];
  try {
    var origPlay = HTMLMediaElement.prototype.play;
    HTMLMediaElement.prototype.play = function () { if (playing.indexOf(this) < 0) playing.push(this); return origPlay.apply(this, arguments); };
  } catch (e) {}
  function mediaPlaying() {
    for (var i = 0; i < playing.length; i++) if (playing[i] && !playing[i].paused && !playing[i].ended) return true;
    var els = document.querySelectorAll('audio,video');
    for (var j = 0; j < els.length; j++) if (!els[j].paused && !els[j].ended) return true;
    return false;
  }

  /* ---- the dialog (built here so a page needs only the include) */
  var root, card, form, input, btn, msg, lastFocus = null, isOpen = false, busy = false;
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function build() {
    root = el('div', 'pbc-xo'); root.setAttribute('aria-hidden', 'true');
    var ov = el('div', 'pbc-xo__overlay'); ov.setAttribute('data-xo-close', '');
    card = el('div', 'pbc-xo__card');
    card.setAttribute('role', 'dialog'); card.setAttribute('aria-modal', 'true'); card.tabIndex = -1;
    card.setAttribute('aria-labelledby', 'pbc-xo-title'); card.setAttribute('aria-describedby', 'pbc-xo-sub');
    var x = el('button', 'pbc-xo__close', '×'); x.type = 'button'; x.setAttribute('aria-label', 'Close'); x.setAttribute('data-xo-close', '');

    var off = el('div', 'pbc-xo__offer');
    off.appendChild(el('p', 'pbc-xo__eyebrow', offer.eyebrow));
    var h = el('h2', 'pbc-xo__title', offer.title); h.id = 'pbc-xo-title'; off.appendChild(h);
    var s = el('p', 'pbc-xo__sub', offer.sub); s.id = 'pbc-xo-sub'; off.appendChild(s);
    form = el('form', 'pbc-xo__form'); form.noValidate = true;
    var lab = el('label', 'pbc-xo__label', 'Your Email'); lab.htmlFor = 'pbc-xo-email';
    input = el('input', 'pbc-xo__input'); input.id = 'pbc-xo-email'; input.type = 'email'; input.name = 'email';
    input.autocomplete = 'email'; input.placeholder = 'you@email.com'; input.required = true;
    input.setAttribute('autocapitalize', 'off'); input.setAttribute('autocorrect', 'off'); input.setAttribute('inputmode', 'email');
    var hp = el('input', 'pbc-xo__hp'); hp.type = 'text'; hp.name = 'website'; hp.tabIndex = -1; hp.autocomplete = 'off'; hp.setAttribute('aria-hidden', 'true');
    btn = el('button', 'pbc-xo__btn', offer.button); btn.type = 'submit';
    msg = el('p', 'pbc-xo__msg'); msg.setAttribute('role', 'alert');
    form.appendChild(lab); form.appendChild(input); form.appendChild(hp); form.appendChild(btn); form.appendChild(msg);
    form.appendChild(el('p', 'pbc-xo__fine', 'No checkout. Unsubscribe anytime.'));
    off.appendChild(form);
    var skip = el('button', 'pbc-xo__skip', 'No Thanks'); skip.type = 'button'; skip.setAttribute('data-xo-close', '');
    off.appendChild(skip);

    var sent = el('div', 'pbc-xo__result pbc-xo__result--sent');
    sent.appendChild(el('h2', 'pbc-xo__title', offer.sentTitle));
    sent.appendChild(el('p', 'pbc-xo__sub', offer.sentBody));
    var ok1 = el('button', 'pbc-xo__btn', 'Back To The Page'); ok1.type = 'button'; ok1.setAttribute('data-xo-close', ''); sent.appendChild(ok1);

    var owned = el('div', 'pbc-xo__result pbc-xo__result--owned');
    owned.appendChild(el('h2', 'pbc-xo__title', offer.ownedTitle));
    owned.appendChild(el('p', 'pbc-xo__sub', offer.ownedBody));
    var ok2 = el('button', 'pbc-xo__btn', 'Back To The Page'); ok2.type = 'button'; ok2.setAttribute('data-xo-close', ''); owned.appendChild(ok2);

    card.appendChild(x); card.appendChild(off); card.appendChild(sent); card.appendChild(owned);
    root.appendChild(ov); root.appendChild(card);
    document.body.appendChild(root);

    var ctx = window.PBC_XO_CTX;
    if (ctx && ctx.email) input.value = ctx.email;                   /* logged-in customer: prefilled */

    root.addEventListener('click', function (e) { if (e.target.closest('[data-xo-close]')) close('dismiss'); });
    document.addEventListener('keydown', onKey, true);
    form.addEventListener('submit', onSubmit);
    input.addEventListener('input', function () { input.removeAttribute('aria-invalid'); msg.textContent = ''; });
  }
  function focusables() { return Array.prototype.filter.call(card.querySelectorAll('button,input:not([tabindex="-1"]),a[href]'), function (n) { return n.offsetParent !== null && !n.disabled; }); }
  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close('dismiss'); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === card)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  function open() {
    if (isOpen || otherDialogOpen()) return;
    if (!root) build();
    isOpen = true; teardownTriggers();
    lastFocus = document.activeElement;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false');
    stampSeen();
    /* touch: focus the dialog, not the input (no surprise keyboard). desktop: straight into the email field */
    setTimeout(function () { (isTouch ? card : input).focus({ preventScroll: true }); }, 60);
    emit('shown');
  }
  function close(why) {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    emit(why || 'dismiss');
  }
  function show(state) { root.classList.add(state); var t = card.querySelector('.pbc-xo__result--' + state.replace('is-', '') + ' .pbc-xo__btn'); if (t) t.focus({ preventScroll: true }); }

  /* ---- layer (c): server check BEFORE send. No endpoint = local demo that posts NOTHING. Errors fail CLOSED. */
  function check(email) {
    var endpoint = attr('data-endpoint');
    var payload = { action: 'free_claim', email: email, kit: kitName, free: offer.freeKey, freeHandle: offer.freeHandle, paidHandle: offer.paidHandle, page: location.pathname };
    if (!endpoint) {
      console.info('[exit-offer demo] would POST (nothing sent):', payload);
      return new Promise(function (res) {
        setTimeout(function () {
          if (/\+fail@/i.test(email)) res({ status: 'error' });
          else if (/\+owned@/i.test(email)) res({ status: 'owned' });
          else res({ status: 'sent' });
        }, 500);
      });
    }
    return fetch(endpoint, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); });
  }
  function onSubmit(e) {
    e.preventDefault();
    if (busy) return;
    if (form.elements.website && form.elements.website.value) return;  /* bot trap */
    var email = input.value.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      input.setAttribute('aria-invalid', 'true'); msg.textContent = 'Enter a real email so it has somewhere to land.'; input.focus(); return;
    }
    busy = true; msg.textContent = ''; btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Checking…';
    emit('submit');
    check(email).then(function (j) {
      var st = j && j.status;
      if (st === 'owned') { markHave(offer.freeKey); show('is-owned'); emit('owned'); return; }
      if (st === 'sent') { markHave(offer.freeKey); show('is-sent'); emit('sent'); return; }
      throw new Error('bad status');
    })['catch'](function () {
      msg.textContent = 'That did not go through. Try again in a second.';
      emit('error');
    }).then(function () { busy = false; btn.removeAttribute('aria-disabled'); btn.textContent = offer.button; });
  }

  /* ---- triggers */
  var isTouch = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches;
  var t0 = Date.now(), maxDepth = 0, idleTimer = null, samples = [], listeners = [];
  function on(target, ev, fn, opt) { target.addEventListener(ev, fn, opt); listeners.push([target, ev, fn, opt]); }
  function teardownTriggers() { listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); }); listeners = []; clearTimeout(idleTimer); }
  function depth() { var h = document.documentElement.scrollHeight - window.innerHeight; return h > 0 ? (window.scrollY / h) * 100 : 100; }
  function typing() { var a = document.activeElement; return a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.isContentEditable); }
  function fire(src) { if (typing() || otherDialogOpen()) return; emit('trigger', { source: src }); open(); }

  function armDesktop() {
    /* exit intent = the cursor leaves the viewport through the top edge (toward tabs / URL bar / back button) */
    on(document, 'mouseout', function (e) {
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 8) return;
      if (Date.now() - t0 < CFG.armMs) return;
      fire('mouse-top');
    });
  }
  function armTouch() {
    /* no back-button / history trap (hostile). Two signals instead: a fast scroll back up, or 30s idle deep in the page. */
    function resetIdle() {
      clearTimeout(idleTimer);
      if (maxDepth < CFG.idleMinDepth) return;
      idleTimer = setTimeout(function () {
        if (mediaPlaying() || document.hidden) { resetIdle(); return; }
        fire('idle');
      }, CFG.idleMs);
    }
    on(window, 'scroll', function () {
      var now = Date.now(), y = window.scrollY;
      maxDepth = Math.max(maxDepth, depth());
      samples.push([now, y]);
      while (samples.length && now - samples[0][0] > CFG.fastUpMs) samples.shift();
      var up = samples.length ? samples[0][1] - y : 0;
      if (now - t0 >= CFG.mobileDwellMs && maxDepth >= CFG.fastUpMinDepth && up >= window.innerHeight * CFG.fastUpPx && y > 80) { fire('fast-scroll-up'); return; }
      resetIdle();
    }, { passive: true });
    ['touchstart', 'pointerdown', 'keydown'].forEach(function (ev) { on(window, ev, resetIdle, { passive: true }); });
    on(document, 'visibilitychange', resetIdle);
  }

  function start(manual) {
    var why = manual ? '' : blockedReason();
    if (why) { emit('skipped', { reason: why }); return; }
    cartCheck().then(function (c) {
      if (c) { if (c === 'in-cart-free') markHave(offer.freeKey); emit('skipped', { reason: c }); return; }
      if (force || manual) { open(); return; }
      if (isTouch) armTouch(); else armDesktop();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(false); });
  else start(false);
})();
